"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _BaseTheme = _interopRequireDefault(require("../../Themes/BaseTheme"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const Success = () => /*#__PURE__*/_react.default.createElement("svg", {
  viewBox: "0 0 32 32"
}, /*#__PURE__*/_react.default.createElement("path", {
  fill: _BaseTheme.default.colors.green,
  d: "M16,26 C21.5228475,26 26,21.5228475 26,16 C26,10.4771525 21.5228475,6 16,6 C10.4771525,6 6,10.4771525 6,16 C6,21.5228475 10.4771525,26 16,26 Z M21.1115436,12.2117874 C21.1136666,12.2139002 21.1157765,12.2160262 21.1178732,12.2181651 C21.4035744,12.5096144 21.4018083,12.9766185 21.113911,13.2658986 L14.6420442,19.7688496 C14.6139441,19.7970847 14.5841017,19.8225304 14.5528612,19.845186 L14.6179008,19.7874761 C14.3345668,20.0727873 13.8735888,20.0743901 13.5882777,19.7910561 L13.5824863,19.7852397 L10.8806833,17.0409738 C10.5944489,16.7502408 10.5954574,16.2833138 10.8829451,15.99382 C11.1662791,15.7085088 11.6272571,15.706906 11.9125683,15.99024 L11.9183596,15.9960564 L14.1066667,18.219 L20.083005,12.2142515 C20.3663477,11.9295479 20.82684,11.9284447 21.1115436,12.2117874 Z"
}));

var _default = Success;
exports.default = _default;